/* eslint-disable import/no-default-export */
import * as React from 'react';
import { mergeStyles, IStyleConfig } from '@cian/utils';

import * as styles from './checkbox_field.css';

export interface ICheckboxFieldProps extends React.Props<CheckboxField> {
  containerStyle?: IStyleConfig;
  invalid?: boolean;
  disabled?: boolean;
  label: React.ReactNode;
  labelStyle?: IStyleConfig;
  mobile?: boolean;
  onValueChange: (value: boolean) => void;
  required?: boolean;
  value: boolean;
}

export default class CheckboxField extends React.Component<ICheckboxFieldProps, {}> {
  public render() {
    const { value, required, invalid, disabled, mobile } = this.props;

    return (
      <span
        {...mergeStyles(
          styles['container'],
          !!value && styles['checked'],
          required && styles['required'],
          invalid && styles['invalid'],
          disabled && styles['disabled'],
          mobile && styles['mobile'],
          this.props.containerStyle,
        )}
      >
        <label
          {...mergeStyles(styles['label'], mobile && styles['mobile'], this.props.labelStyle)}
          onClick={() => this.handleClick()}
        >
          {this.props.label}
        </label>
      </span>
    );
  }

  private handleClick() {
    if (this.props.disabled) {
      return;
    }

    this.props.onValueChange(!this.props.value);
  }
}
